import React from 'react';
import styled from 'styled-components';
import { FaUser } from 'react-icons/fa';

const HeaderContainer = styled.header`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1440px;
  height: 85px;
  background: #FFFFFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  z-index: 10;

  @media (max-width: 768px) {
    position: static;
    transform: none;
    width: 100%;
    height: auto;
    padding: 16px;
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column-reverse; /* Inverte a ordem no mobile */
    gap: 16px;
    width: 100%;
    align-items: center;
  }
`;

const NavLinks = styled.nav`
  display: flex;
  gap: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
`;

const NavItem = styled.a`
  font-size: 16px;
  color: #4A4A4A;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    align-items: center;
  }
`;

const AccessButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 1px solid #2FB65D;
  background: transparent;
  color: #2FB65D;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background: #2FB65D;
    color: #fff;
  }

  @media (max-width: 768px) {
    width: 90%;
    justify-content: center;
  }
`;

const RequestButton = styled.a`
  padding: 10px 20px;
  border-radius: 6px;
  background: linear-gradient(90deg, #2FB65D 0%, #003960 100%);
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    width: 90%;
    text-align: center;
  }
`;

function Header() {
  return (
    <HeaderContainer>
      <img
        src="/images/logo-header-nacao.png"
        alt="Nação Saúde"
        style={{ height: '40px' }}
      />
      <ContentWrapper>
        <NavLinks>
          <NavItem href="https://nacaosaude.clubeparcerias.com.br/member/login">
            Meu Clube
          </NavItem>
          <NavItem href="https://api.whatsapp.com/send/?phone=5511916235625&text=Oi%2C+estou+precisando+de+atendimento&type=phone_number&app_absent=0">
            Entre em Contato
          </NavItem>
        </NavLinks>
        <ButtonGroup>
          <AccessButton href="https://nacaosaude.centraldeatendimento.me/login">
            <FaUser size={14} />
            Meu Acesso
          </AccessButton>
          <RequestButton href="https://nacaosaude.centraldeatendimento.me/rede">
            Rede Credenciada
          </RequestButton>
        </ButtonGroup>
      </ContentWrapper>
    </HeaderContainer>
  );
}

export default Header;
